import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from '../HomePage/HomePage';
import AboutUsPage from '../AboutUsPage/AboutUsPage';
import TeamPage from '../TeamPage/TeamPage';
import ContactPage from '../ContactPage/ContactPage';

import StatisticsPage from '../../components/StatisticsPage/StatisticsPage'
import MyEventPage from '../../components/StatisticsPage/EventPage'
import Gallery from '../Gallery/Gallery'
import LiveCounts from '../../components/LiveCounts/LiveCounts';
import RegistrationPage from '../../components/registration/RegistrationPage';
import MyTeamPage from '../../main-component/MyTeamPage/myTeamMain';
import RegisterDonorForm from '../../components/RegisterDonor/RegisterDonorForm';
import DonationListing from '../DonationListing/DonationListing';
import DonationSinglePage from '../DonationSinglePage/DonationSinglePage';
import ScrollToTop from '../../components/ScrollToTop/ScrollToTop';

const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/blooddonation/home" element={<HomePage />} />
          <Route path="/blooddonation/stats" element={<StatisticsPage />} />
          <Route path="/blooddonation/gallery" element={<Gallery />} /> 
          <Route path="/blooddonation/about" element={<AboutUsPage />} />
          <Route path="/blooddonation/donation-listing" element={<DonationListing />} />
          <Route path="/blooddonation/donation-details/:slug" element={<DonationSinglePage />} />
          <Route path="/blooddonation/events" element={<MyEventPage />} />
          <Route path="/blooddonation/volunteers" element={<TeamPage />} />
          <Route path="/blooddonation/contact" element={<ContactPage />} />
          <Route path="/blooddonation/live-counts" element={<LiveCounts />} />
          <Route path="/blooddonation/register" element={<RegistrationPage />} />
          <Route path="/blooddonation/myTeamPage" element={<MyTeamPage />} />
          <Route path="/blooddonation/register-donor" element={<RegisterDonorForm />} />
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default AllRoute;